function addCapPackToCart(variantId, event) {
    event.preventDefault();
    if (!variantId) return;
    
    let btn = event.currentTarget;
    btn.style.opacity = '0.5';
    
    const isAdded = btn.classList.contains('clicked-state');

    if (isAdded) {
      let formData = {
        'id': variantId,
        'quantity': 0
      };

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        btn.style.opacity = '1';
        btn.classList.remove('clicked-state');
        if (typeof updateHeaderCartCount === 'function') {
          updateHeaderCartCount();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(error => {
        console.error('Error:', error);
        btn.style.opacity = '1';
      });
    } else {
      let formData = {
        'items': [{
          'id': parseInt(variantId),
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        btn.style.opacity = '1';
        btn.classList.add('clicked-state');
        if (typeof updateHeaderCartCount === 'function') {
          updateHeaderCartCount();
        }
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
      })
      .catch(error => {
        console.error('Error:', error);
        btn.style.opacity = '1';
      });
    }
  }

document.addEventListener("DOMContentLoaded", function() {
  function initCapGrid() {
    const capGrid = document.querySelector('.cap-grid');
    const capLoadMore = document.getElementById('cap-load-more');
    const capFooter = document.querySelector('.cap-footer');
    
    if (capGrid && capLoadMore && capFooter) {
      const cards = capGrid.querySelectorAll('.cap-product-card');
      
      function checkMobileState() {
        if (window.innerWidth <= 767) {
          if (cards.length > 4) {
            capGrid.classList.add('mobile-collapsed');
            capFooter.style.display = 'block';
          } else {
            capGrid.classList.remove('mobile-collapsed');
            capFooter.style.display = 'none';
          }
        } else {
          capGrid.classList.remove('mobile-collapsed');
          capFooter.style.display = 'none';
        }
      }
      
      checkMobileState();
      window.addEventListener('resize', checkMobileState);
      
      capLoadMore.addEventListener('click', function() {
        capGrid.classList.remove('mobile-collapsed');
        capFooter.style.display = 'none';
      });
    }
  }
  
  initCapGrid();
});

// For deferred scripts, DOMContentLoaded might have already fired.
(function() {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // We can't easily re-declare functions, so we just run the same logic.
    const capGrid = document.querySelector('.cap-grid');
    const capLoadMore = document.getElementById('cap-load-more');
    const capFooter = document.querySelector('.cap-footer');
    
    if (capGrid && capLoadMore && capFooter) {
      const cards = capGrid.querySelectorAll('.cap-product-card');
      
      function checkMobileState() {
        if (window.innerWidth <= 767) {
          if (cards.length > 4) {
            capGrid.classList.add('mobile-collapsed');
            capFooter.style.display = 'block';
          } else {
            capGrid.classList.remove('mobile-collapsed');
            capFooter.style.display = 'none';
          }
        } else {
          capGrid.classList.remove('mobile-collapsed');
          capFooter.style.display = 'none';
        }
      }
      
      checkMobileState();
      window.addEventListener('resize', checkMobileState);
      
      capLoadMore.addEventListener('click', function() {
        capGrid.classList.remove('mobile-collapsed');
        capFooter.style.display = 'none';
      });
    }
  }
})();
